<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="col-8 offset-2 beast-organization-header">
          <h1>New Organization</h1>
        </div>
      </div>
      <div class="row">
        <div class="alert col-8 offset-2 alert-danger"
             v-if="errorMessage"
             v-text="errorMessage"></div>

        <div class="col-8 offset-2 beast-organization-info">
          <div class="form-group">
            <label>Organization Name</label>
            <input type="text" v-model="org.name" class="form-control"/>
          </div>
          <div class="form-group">
            <label>Organization Slug</label>
            <input type="text" v-model="org.slug" class="form-control"/>
          </div>
          <button class="btn btn-block btn-success" @click="storeOrg">
            Create
          </button>
          <button class="btn btn-block btn-link" @click="goBack">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<style scoped lang="scss">
  .beast-organization-header {
  }

</style>

<script>
import BeastHeader from "../../components/header/BeastHeader.vue";
import BeastFooter from "../../components/footer/BeastFooter.vue";

export default {
  components: {
    BeastFooter,
    BeastHeader
  },
  watch: {
    "org.name": function onOrganizationNameChange(value) {
      this.org.slug = `@${value}`.toLowerCase().replace(/ /gi, "-");
    }
  },
  data() {
    return {
      errorMessage: "",
      org: {
        name: "",
        slug: "",
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async storeOrg() {
      try {
        await this.axios.post("/organizations", this.org);
        this.$router.push(`/organization/${this.org.slug}`);
      } catch (e) {
        this.errorMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.errorMessage = "";
        }, 2500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },

  async beforeMount() {
    this.setTitle("New Organization");
  }
};
</script>
